module.exports = __webpack_public_path__ + "img/170-10-CMS 4_3.92dff978.png";